export const toggleModal = "toggleModal"
export const ADD_EMPLOYEE_TO_LIST = "ADD_EMPLOYEE_TO_LIST"
export const UPDATE_EMPLOYEE_IN_LIST = "UPDATE_EMPLOYEE_IN_LIST"
export const UPDATE_ADMIN_IN_LIST = "UPDATE_ADMIN_IN_LIST"
export const DELETE_EMPLOYEE_FROM_LIST = "DELETE_EMPLOYEE_FROM_LIST"
export const DEACTIVATE_EMPLOYEE_FROM_LIST = "DEACTIVATE_EMPLOYEE_FROM_LIST"
export const ACTIVATE_EMPLOYEE_FROM_LIST = "ACTIVATE_EMPLOYEE_FROM_LIST"
export const ADD_EMPLOYEES_TO_LIST = "ADD_EMPLOYEES_TO_LIST"
